module.exports = __webpack_public_path__ + "img/ปลาแมกเคอเรล.9e7558d5.jpg";